import { propertyToStringForEdit } from "../helper/alert/condition";

export const getPropertyOptions = (isnIsIndex: boolean) => {
  if (isnIsIndex) {
    return [
      { value: "", label: propertyToStringForEdit("") },
      { value: "LTP", label: propertyToStringForEdit("LTP") },
    ];
  }
  
  return [
    { value: "", label: propertyToStringForEdit("") },
    { value: "LTP", label: propertyToStringForEdit("LTP") },
    { value: "AVGPRICE", label: propertyToStringForEdit("AVGPRICE") },
    { value: "VOLUME", label: propertyToStringForEdit("VOLUME") },
  ];
};